import { alpha, Box, Card, styled, Theme } from '@ltvco/refresh-lib/theme';

const articleTileOutline = (theme: Theme) =>
  `0 0 0 1px ${alpha(theme.palette.button.main, 0.25)}`;

export const ArticlesCard = styled(Card)(({ theme }) => ({
  boxShadow: articleTileOutline(theme),
}));

/**
 * Overrides box-shadow on article tiles from `@ltvco/refresh-lib` `<Articles />`
 * without editing the library (same pattern as `StyledContainer` in DashboardParent).
 */
export const GarageArticlesWrapper = styled(Box)(({ theme }) => ({
  '&& > .MuiStack-root > .MuiStack-root > .MuiStack-root': {
    boxShadow: articleTileOutline(theme),
  },
}));
